import PropTypes from 'prop-types';
import { useState } from 'react';
import Text from '../../assets/styles/Text';
import * as styles from './styles';

export default function Ad({ img, link = null }) {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  function handleImageLoad() {
    setIsLoading(false);
  }

  function handleImageError() {
    setIsLoading(false);
    setHasError(true);
  }

  return (
    <styles.Container className="ads">
      <Text.Span>Anúncio</Text.Span>

      <styles.StyledLink
        href={link}
        target="blank"
        $disabled={!link}
        $loading={isLoading}
      >
        {isLoading && <styles.Skeleton />}

        {!hasError && (
          <img
            src={img}
            alt="Anúncio"
            onLoad={handleImageLoad}
            onError={handleImageError}
          />
        )}
      </styles.StyledLink>

      {hasError && (
        <styles.Error>
          <Text.Span>Erro ao carregar anúncio</Text.Span>
        </styles.Error>
      )}
    </styles.Container>
  );
}

Ad.propTypes = {
  img: PropTypes.string.isRequired,
  link: PropTypes.string,
};
